/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ExternalConstraint = core.serialization.object({
    validator: core.serialization.string(),
    description: core.serialization.string().optional(),
    label: core.serialization.string().optional(),
    config: core.serialization.any().optional(),
});
